import { useQuery } from '@tanstack/react-query';
import { type SupportedLocaleMap } from '@zep-us/i18n';

import { getCmsContent } from '@/api/cms/client';
import { CMS_CONTENT_IDS } from '@/api/cms/constants';

type PricingContent = {
  questions: {
    question: SupportedLocaleMap<'ko' | 'en' | 'ja'>;
    answer: SupportedLocaleMap<'ko' | 'en' | 'ja'>[];
  }[];
};

export const usePricingContent = () => {
  const { data } = useQuery({
    queryKey: ['pricing-content', CMS_CONTENT_IDS.PRICING_FAQ],
    queryFn: () =>
      getCmsContent<PricingContent>({
        contentId: CMS_CONTENT_IDS.PRICING_FAQ,
      }),
    staleTime: 10 * 60 * 1000, // 10 minutes cache for pricing content
  });

  return {
    data,
  };
};
